import {
  IfpApplicationState,
  LoanOfferItem,
  SecLoanApplicationState,
  SecLoanApplicationType,
  SecLoanPurposeType,
  SecLoansApplicationMetadata,
} from '@shared/sec-loans'

export type { User } from '@sec-loans-ui/wizard/types'

export enum ApplicationType {
  LoanApplication = 'loan',
  InstalmentFreePeriodApplication = 'ifp',
  LoanOffer = 'loanOffer',
}

export interface AuthenticatedContext {
  authToken: string
}

export interface SecLoansApplicationSelectData {
  applicationType: SecLoanApplicationType
  applicationPurpose: SecLoanPurposeType
}

export type ApplicationSelectData =
  | {
      applicationId: string
      applicationType: ApplicationType.LoanApplication
      data: SecLoansApplicationSelectData
    }
  | {
      applicationId: string
      applicationState: IfpApplicationState
      applicationType: ApplicationType.InstalmentFreePeriodApplication
    }
  | {
      id: string
      applicationType: ApplicationType.LoanOffer
      loanOffer?: LoanOfferItem
    }

export type SecLoanApplicationVisibleState = Exclude<SecLoanApplicationState, SecLoanApplicationState.OfferReceived>

export type SecLoansApplicationVisibleMetadata = SecLoansApplicationMetadata & {
  applicationState: SecLoanApplicationVisibleState
}

export const isVisibleSecLoanApplication = (
  a: SecLoansApplicationMetadata,
): a is SecLoansApplicationVisibleMetadata => {
  return a.applicationState !== SecLoanApplicationState.OfferReceived
}
